import AssemblePositioningDeviceInfoModal from './assemble-positioning-device-info-modal.vue'
export default AssemblePositioningDeviceInfoModal
